import CNLogo from '../../components/CNLogo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowCircleLeft,
} from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Logo from '../OnboardingRevampPage/Logo';

export default function PricingNavbar({route,setExitModal,userToggle,isCareerGoal,setIsCareerGoal,defaultState}) {
  const navigate = useNavigate();
  const isBlocked = useSelector(store=> store?.userActivity?.user_trial_blocked);
  const prevUrl = useSelector(store => store?.search?.prevUrl);
  // console.log('navbar' , isCareerGoal?.is_show , defaultState);
  return (
    <>
      <div className="bg-white flex justify-center relative w-full items-center  py-2 shadow-lg px-2 md:px-8">

       {route!==2 && 
          <div className="absolute cursor-pointer text-xs md:text-sm font-bold justify-between items-center border-2  border-slate-800 rounded py-2 px-2 bg-white hover:bg-zinc-50 hover:text-black left-3 md:left-10 flex" 
          onClick={(e)=> 
          {
            if(isBlocked && isCareerGoal?.is_show ){
              setIsCareerGoal((prev)=>({...prev , is_show : false}))
          }
          else if(isBlocked){
            setExitModal(true);
          }
          else if(userToggle){
        
            if(prevUrl?.length > 0){
              navigate(prevUrl);
            }
            else{
              navigate('/courses')
            }
          
          
          }
          else if(defaultState && isCareerGoal?.is_show){
            setIsCareerGoal((prev)=>({...prev , is_show : false}))
            // switch (user_role) {
            //   case 1:
            //     return setActiveCard(cardDatas?.[0]);
            //   case 2:
            //     return setActiveCard(cardDatas?.[1]);
            //   case 4:
            //     return setActiveCard(cardDatas?.[2]);
            //   case 6:
            //     return setActiveCard(cardDatas?.[2]);
      
            //   default:
            //     break;
            // }
          }
          else{
            if(prevUrl?.length > 0){
              navigate(prevUrl);
            }
            else{
              navigate('/courses')
            }
          
          }
        }}>

            <FontAwesomeIcon
              icon={faArrowCircleLeft}
              className="text-lg md:text-base"
             />
          </div>
         }
        <div className="flex justify-center items-center scale-90 x-4">
          <a onClick={(event)=> {
         } }>
             <div className={`w-fit bg-white flex items-center  rounded-md p-2  md:p-2 gap-2`}>
                                  <img src="https://assets.learntube.ai/files/post-payment-updates/image%2011.svg?updatedAt=1728356261811" loading="eager" alt=""  className='h-[31px] w-[31px] md:h-[35px] md:w-[35px]'/>
                                  <p className='text-md font-medium md:text-lg md:flex text-black'>LearnTube.ai</p>
                              </div>
          </a>
        </div>
      </div>
    </>
  );
}
